import type { AppRoute } from 'src/shared/routes';

/**
 * No routes configured at top level. See the details, comment, and comments sub-folders.
 */
export const ROUTES: readonly AppRoute[] = [];
